import Editor from './base/editor';
export default Editor.extend({
  width: 400,
  height: 35,
  classNames: ['is-light-theme', 'composer-video-editor']
});